export default __webpack_public_path__ + "static/media/3.57c632d5.png";